module.exports = __webpack_public_path__ + "img/48600d2f93f19b9b3654a722d6163418.svg";